import styled from "styled-components";

export const SparklineStyles = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
`;
